import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { ExternalMatchRequestRuleType } from 'generated/graphql';

export const RuleTypeChip = ({ active, type }: { active: boolean; type: string }) => {
  const theme = useTheme();

  const chipLabel = type === ExternalMatchRequestRuleType.Approval ? 'Auto-Approve' : 'Auto-Deny';
  const chipColor = active
    ? type === ExternalMatchRequestRuleType.Approval
      ? theme.palette.success.dark
      : theme.palette.error.dark
    : theme.palette.grey[400];

  return (
    <Chip
      label={chipLabel}
      sx={{
        justifySelf: 'start',
        color: chipColor,
        borderColor: chipColor,
        backgroundColor: active
          ? type === ExternalMatchRequestRuleType.Approval
            ? theme.palette.success.light
            : 'rgba(211, 47, 47, 0.04)'
          : 'rgba(0, 0, 0, 0.04)',
      }}
      variant="outlined"
    />
  );
};

export default RuleTypeChip;
